import Vue from 'vue';
import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

const originalMessage = Vue.prototype.$message;

const notifyHandler = (instance, options) => {
  emit(EVENT_TYPES.UI_MESSAGE, options);

  const messageEle = instance.$el;
  if (options.showClose) {
    const closeBtn = messageEle?.querySelector('.zm-message__closeBtn');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        emit(EVENT_TYPES.UI_MESSAGE_CLICK_CLOSE, options);
      });
    }
  }

  const links = messageEle?.querySelectorAll('a[href]');
  links.forEach((link) => {
    link.addEventListener('click', () => {
      emit(EVENT_TYPES.UI_MESSAGE_CLICK_LINK, {
        linkText: link.textContent,
        ...options,
      });
    });
  });
};

let interceptMessage = (options) => {
  const instance = originalMessage(options);
  notifyHandler(instance, options);
  return instance;
};

Object.keys(originalMessage).forEach((type) => {
  if (['success', 'warning', 'info', 'error'].includes(type)) {
    interceptMessage[type] = (options) => {
      if (typeof options === 'string') {
        options = {
          message: options,
        };
      }

      options.type = type;

      const instance = originalMessage[type](options);
      notifyHandler(instance, options);

      return instance;
    };
  } else {
    interceptMessage[type] = (...params) => {
      return originalMessage[type](params);
    };
  }
});

Vue.prototype.$message = interceptMessage;
